
import Header from '../components/Header';
import Component1 from "../components/Component1"
import Component2 from "../components/Component2"
import Component3 from "../components/Component3"
import Component4 from "../components/Component4"



function Home() {
  return (
    <>
      <Header /> 
      <Component1/>
      <Component2/>
      <Component3/>
      <Component4/>
    </>
  
  );
}

export default Home;